export const addresses = {
  font:"0xeC20dCBf0380F1C9856Ee345aF41F62Ee45a95a1",
}
